import { Book, Text } from '@doda/io-react/common';
import React from 'react';
import styles from './index.module.scss';

/** おしごと用語集リンク */
export const JobGlossaryLink = () => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault();
    const { href } = event.currentTarget;
    const windowFeatures = 'popup,width=782,height=426,';
    window.open(href, 'job-glossary', windowFeatures);
  };

  return (
    <a
      href="/info/help/about_job_glossary.html"
      onClick={handleClick}
      className={styles['jobSearchDetail-jobGlossaryLink']}
    >
      <Book color="blue" size="XS" />
      <Text color="blue" size="12" weight="normal" as="span">
        おしごと用語集
      </Text>
    </a>
  );
};
